import { Send, X } from 'lucide-react';
import { useMemo, useState } from 'react';

export default function CollectionDrawer({ articles, onClose, onCreate }) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [region, setRegion] = useState('');
  const [audience, setAudience] = useState('DMOs, Travel Agencies');
  const [tone, setTone] = useState('Professional, Informative');
  const [language, setLanguage] = useState('German');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const articleIds = useMemo(() => articles.map((article) => article.id), [articles]);

  async function submit(event) {
    event.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      await onCreate({
        name,
        description,
        article_ids: articleIds,
        metadata: {
          region,
          target_audience: audience,
          tone,
          language,
        },
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="drawer-backdrop" role="dialog" aria-modal="true">
      <form className="collection-drawer" onSubmit={submit}>
        <header className="modal-header">
          <div>
            <span className="eyebrow">Create Collection</span>
            <h2>{articles.length} Artikel</h2>
          </div>
          <button className="icon-button" onClick={onClose} type="button" title="Schliessen">
            <X size={18} />
          </button>
        </header>
        {error ? <div className="alert">{error}</div> : null}
        <label>
          Collection Name
          <input value={name} onChange={(event) => setName(event.target.value)} required placeholder="Bayern Wochenbrief KW20" />
        </label>
        <label>
          Description
          <textarea
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            rows={4}
            placeholder="Top tourism news from this week"
          />
        </label>
        <div className="two-col">
          <label>
            Region
            <input value={region} onChange={(event) => setRegion(event.target.value)} placeholder="Bayern" />
          </label>
          <label>
            Language
            <select value={language} onChange={(event) => setLanguage(event.target.value)}>
              <option>German</option>
              <option>English</option>
            </select>
          </label>
        </div>
        <label>
          Target Audience
          <input value={audience} onChange={(event) => setAudience(event.target.value)} />
        </label>
        <label>
          Tone
          <input value={tone} onChange={(event) => setTone(event.target.value)} />
        </label>
        <div className="selected-list">
          {articles.map((article, index) => (
            <div key={article.id}>
              <span>{index + 1}</span>
              <p>{article.title}</p>
            </div>
          ))}
        </div>
        <footer className="modal-actions">
          <button className="secondary-button" onClick={onClose} type="button">
            Cancel
          </button>
          <button className="primary-button" disabled={submitting || articles.length === 0} type="submit">
            <Send size={16} />
            {submitting ? 'Speichern...' : 'Save Collection'}
          </button>
        </footer>
      </form>
    </div>
  );
}
